import { PUBLICATION_STATE } from '~/scopes/listings/Listings.constants'
import { ORDER_BY } from '~/scopes/listings/pages/index/components/Ordering/Ordering.constants'

export const INITIAL_FILTERS_VALUES = {
  aestheticGrade: '',
  bmId: '',
  categoryId: '',
  hasBackbox: '',
  hasNewBattery: '',
  hasStock: '',
  market: '',
  orderBy: ORDER_BY.STOCK_DESC,
  page: 1,
  pageSize: '10',
  priceOverNew: '',
  productId: '',
  sku: '',
  title: '',
}

export const OPTION_VALUE_ALL = ''

export const FILTER_FIELDS = {
  TITLE: 'title',
  SKU: 'sku',
  UUID: 'uuid',
  BACKMARKET_ID: 'backmarketId',
  GRADE: 'grade',
  BACKBOX: 'backbox',
  STOCK: 'stock',
  ALERT: 'alert',
  MARKET: 'market',
  CATEGORY_ID: 'categoryId',
  HAS_NEW_BATTERY: 'hasNewBattery',
}

export const FILTER_FIELDS_LIST = Object.values(FILTER_FIELDS)

export const FILTERS_BY_PUBLICATION_STATE = {
  [PUBLICATION_STATE.ONLINE]: FILTER_FIELDS_LIST,
  [PUBLICATION_STATE.MISSING_PRICE_OR_COMMENT]: [
    FILTER_FIELDS.TITLE,
    FILTER_FIELDS.SKU,
    FILTER_FIELDS.GRADE,
    FILTER_FIELDS.CATEGORY_ID,
    FILTER_FIELDS.MARKET,
    FILTER_FIELDS.HAS_NEW_BATTERY,
  ],
  [PUBLICATION_STATE.IN_VALIDATION]: [
    FILTER_FIELDS.TITLE,
    FILTER_FIELDS.SKU,
    FILTER_FIELDS.GRADE,
    FILTER_FIELDS.CATEGORY_ID,
    FILTER_FIELDS.HAS_NEW_BATTERY,
  ],
  [PUBLICATION_STATE.DISABLED]: [
    FILTER_FIELDS.TITLE,
    FILTER_FIELDS.SKU,
    FILTER_FIELDS.GRADE,
    FILTER_FIELDS.CATEGORY_ID,
    FILTER_FIELDS.HAS_NEW_BATTERY,
  ],
}
